import React, { useEffect, useState } from "react";
import { Download, Share, X, Smartphone } from "lucide-react";

// Invite d'installation PWA (Android/Chrome via beforeinstallprompt, iOS via instructions).
export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [iosHint, setIosHint] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("pg_install_dismissed")) return;
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone) return;

    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);

    const ua = window.navigator.userAgent.toLowerCase();
    const isIOS = /iphone|ipad|ipod/.test(ua) && !window.MSStream;
    const isSafari = isIOS && /safari/.test(ua) && !/crios|fxios/.test(ua);
    if (isIOS && isSafari) { setIosHint(true); setShow(true); }

    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const dismiss = () => { localStorage.setItem("pg_install_dismissed", "1"); setShow(false); };
  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try { await deferred.userChoice; } catch {}
    setDeferred(null); dismiss();
  };

  if (!show) return null;
  return (
    <div className="fixed bottom-4 inset-x-4 z-[65] max-w-md mx-auto" data-testid="install-prompt">
      <div className="rounded-2xl p-4 shadow-2xl backdrop-blur-xl flex items-start gap-3"
        style={{ background: "var(--pg-bg-card)", border: "1px solid var(--pg-gold)", boxShadow: "var(--pg-shadow)" }}>
        <div className="w-11 h-11 rounded-xl overflow-hidden shrink-0 border border-[#F2BC2E]/40">
          <img src="/progere-app-icon.png" alt="PROGÈRE" className="h-11 w-11 object-cover" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-bold text-sm" style={{ color: "var(--pg-text-primary)" }}>Installer l'application PROGÈRE</p>
          {iosHint ? (
            <p className="text-xs mt-1 flex items-center gap-1 flex-wrap" style={{ color: "var(--pg-text-muted)" }}>
              Touchez <Share size={13} style={{ color: "var(--pg-gold)" }} /> « Partager » puis <b style={{ color: "var(--pg-text-secondary)" }}>« Sur l'écran d'accueil »</b>.
            </p>
          ) : (
            <p className="text-xs mt-1" style={{ color: "var(--pg-text-muted)" }}>
              Ajoutez PROGÈRE CRM à votre écran d'accueil — accès rapide et mode hors‑ligne.
            </p>
          )}
          {!iosHint && (
            <button onClick={install} data-testid="install-btn"
              className="btn-gold rounded-full text-sm px-4 py-1.5 mt-2.5 inline-flex items-center gap-2">
              <Download size={14} /> Installer
            </button>
          )}
        </div>
        <button onClick={dismiss} data-testid="install-dismiss" style={{ color: "var(--pg-text-muted)" }} className="hover:opacity-70 shrink-0">
          <X size={18} />
        </button>
      </div>
    </div>
  );
}
